export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isNil(value: unknown): value is undefined | null {
  return value === undefined || value === null;
}
